module.exports = __webpack_public_path__ + "static/roundhouse-94f3972b3d942facb1496d952d96fa03.png";